import type { ObjectMetadata } from '@olytic/foundation';

import { formatMoney } from '../../objects/format';
import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asCheck, asDate, asDateTime, asLabel, createdByField, field, lastModifiedByField, lookup, type Row, show, text } from './kit';

const def = OBJECT_DEFS.prices;

/** A price: one way a product is sold (selling model, scheme, amount or Price Grid), one the default. Rationale: prices.md. */
export const prices: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Price',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('product_name', 'Product', { link: lookup('products', 'product_id') }),
    field('label', 'Label'),
    field('selling_model', 'Selling Model'),
    field('scheme', 'Scheme', { format: asLabel }),
    field('period', 'Period', { format: asLabel }),
    field('unit_price', 'Amount', { format: show(formatMoney) }),
    field('price_grid_name', 'Price Grid', { link: lookup('price-grids', 'price_grid_id') }),
    field('is_default', 'Default', { format: asCheck }),
    field('effective_from', 'From', { format: asDate }),
    field('effective_to', 'Until', { format: asDate }),
    field('created_at', 'Created', { format: asDateTime }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['product_name', 'label', 'selling_model', 'scheme', 'period', 'unit_price', 'price_grid_name', 'is_default', 'effective_from', 'effective_to'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_at', 'created_by_name', 'last_modified_by_name'] },
  ],
  related: [],
  titleOf: (row) => text(row.name),
  searchKeys: ['name', 'product_name', 'band'],
};
